// @ts-nocheck
// Greif UI Kit = fill-more-horizontal
import * as React from "react";

const Ellipsis: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M4.5 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M19.5 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
            />
        </svg>
    );
};

export default React.memo(Ellipsis);
